<template>
    <v-dialog
        v-model="isDialogOpen"
        persistent
        max-width="640">
        <v-card>
          <v-card-title class="title-form">
            {{isEdit ? 'Editar producto':'Agregar producto'}}
          </v-card-title>
            <v-card-text>
              <div class="container-form">

                <div class="div-row-form">
                  <div class="container-input-image" @click="selectFile">
                  <img :src="imageUrl" class="img-selected-form" />
                  <input type="file"
                    ref="fileInput"
                    @change="onFileChange"
                    accept="image/*"
                    style="display: none;"/>
                </div>

                <div class="section-swich-form">
                  <div class="container-input-switch">
                    <div class="title-switch-component" >
                      <h1> Disponible en POS</h1>
                      <h3> Visible en puntos de venta </h3>
                    </div>
                    <v-switch
                      v-model="product.available_pos"
                      color="black"
                      hide-details
                    ></v-switch>
                  </div>
                  <div class="container-input-switch">
                    <div class="title-switch-component" >
                      <h1> Disponible en Self-Ordering</h1>
                      <h3> Visible en kioscos y app comprador </h3>
                    </div>
                    <v-switch
                      v-model="product.available_so"
                      color="black"
                      hide-details />
                  </div>
                  <div class="container-input-switch">
                    <div class="title-switch-component" >
                      <h1> Disponible en Favoritos</h1>
                      <h3> Visible en categoría favoritos </h3>
                    </div>
                    <v-switch
                      v-model="product.favorites"
                      color="black"
                      hide-details />
                  </div>
                </div>

                </div>

                <span style="font-size: 12px; font-weight: 400; color: #757575;">*Campos requeridos</span>

                <v-text-field
                  label="Nombre del producto *"
                  placeholder="Nombre del producto"
                  v-model="product.name"
                  color="#222222"
                  variant="underlined"
                  type="text"
                  :rules="rules.required"/>

                <v-text-field
                  label="Descripción *"
                  placeholder="Descripción"
                  v-model="product.description"
                  color="#222222"
                  variant="underlined"
                  type="text"
                  :rules="rules.required"/>

                  <div class="div-row-form">
                    <v-text-field
                      width="50%"
                      label="Código único del producto (SKU) *"
                      placeholder="Código único del producto (SKU)"
                      v-model="product.sku"
                      color="#222222"
                      variant="underlined"
                      type="text"
                      :rules="rules.required"/>
                    <div class="space-element"/>
                    <v-select
                      width="50%"
                      label="Asociar a POS *"
                      v-model="product.terminal"
                      :items="pos"
                      :rules="rules.required"
                      item-title="name"
                      item-value="_id"
                      variant="underlined"/>
                  </div>

                  <div class="div-row-form">
                    <v-text-field
                      width="50%"
                      label="Precio regular *"
                      placeholder="Precio regular"
                      v-model="product.price"
                      color="#222222"
                      variant="underlined"
                      type="number"
                      :rules="rules.required"/>
                    <div class="space-element"/>
                    <v-text-field
                      width="50%"
                      label="Precio especial (rebajado) *"
                      placeholder="Precio especial (rebajado)"
                      v-model="product.promo_price"
                      color="#222222"
                      variant="underlined"
                      type="number"
                      :rules="rules.required"/>
                  </div>

                  <div class="div-row-form">
                    <v-select
                      width="50%"
                      label="Seleccionar categoría *"
                      v-model="product.category"
                      :items="categories.categories"
                      :rules="rules.required"
                      item-title="name"
                      item-value="_id"
                      variant="underlined"/>
                    <div class="space-element"/>
                    <v-select
                      width="50%"
                      label="Agregar extra"
                      v-model="product.extras"
                      :items="extras.extras"
                      item-title="name"
                      item-value="_id"
                      variant="underlined"
                      multiple/>
                  </div>

                  <div class="div-row-form">
                    <v-text-field
                      width="50%"
                      label="Tiempo de preparación en minutos *"
                      placeholder="Tiempo de preparación en minutos"
                      v-model="product.prep_time"
                      color="#222222"
                      variant="underlined"
                      type="number"
                      :rules="rules.required"/>
                    <div class="space-element"/>
                    <v-select
                      width="50%"
                      label="Productos complementarios"
                      v-model="product.cross_sell"
                      :items="complements.products"
                      item-title="name"
                      item-value="_id"
                      variant="underlined"/>
                  </div>
              </div>
            </v-card-text>
            <v-card-actions>
            <v-btn
            class="btn-cancel-form"
            color="#6E6E6E"
                variant="text"
                rounded="xl"
                @click="isDialogOpen = false">
                Cancelar
            </v-btn>

            <v-btn
                class="btn-action-form"
                rounded="xl"
                color="#FFFFFF"
                :loading="isSavingData"
                :disabled="disableBtn()"
                @click="actionBtn">
                Guardar
            </v-btn>
        </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import terminalsApi from '@/api/terminalsApi'
import catalogApi from '@/api/catalogApi'
import categoriesApi from '@/api/categoriesApi'
import extrasApi from '@/api/extrasApi'
export default {
  name: 'CommerciaVueAddEditProducts',
  emits: ['refreshList'],
  data () {
    return {
      imageData: null,
      imageUrl: require('../../assets/imgs/svgs/upload-img.svg'),
      validData: true,
      isSavingData: false,
      isDialogOpen: false,
      isEdit: false,
      business: this.$store.getters.business,
      user: this.$store.getters.user,
      pos: [],
      categories: [],
      extras: [],
      complements: [],
      product: this.initObj(),
      rules: {
        required: [
          v => !!v || 'Campo requerido.'
        ]
      }
    }
  },
  created () {
    this.getPos()
    this.getCategories()
    this.getExtras()
    this.getComplements()
  },
  watch: {
    'product.terminal' (newValue, oldValue) {
      this.getCategories()
      this.getExtras()
      this.getComplements()
    }
  },
  methods: {
    initObj () {
      return {
        name: null,
        description: null,
        sku: null,
        terminal: null,
        category: null,
        business: null,
        price: null,
        promo_price: null,
        extras: null,
        prep_time: null,
        cross_sell: null,
        available_pos: true,
        available_so: false,
        created_at: null,
        updated_at: null,
        favorites: false,
        _id: null
      }
    },
    add () {
      this.product = this.initObj()
      this.imageUrl = require('../../assets/imgs/svgs/upload-img.svg')
      this.product.available_pos = true
      this.product.available_so = false
      this.product._id = '-'
      this.product.updated_at = Date.now()
      this.product.created_at = Date.now()
      this.product.business = this.business._id
      this.isDialogOpen = true
      this.isEdit = false
    },
    edit (obj) {
      this.isDialogOpen = true
      this.isEdit = true
      this.product = structuredClone(obj)
      this.imageUrl = obj.img || require('../../assets/imgs/svgs/upload-img.svg')
      this.getComplements()
    },
    disableBtn () {
      const excludeKeys = ['cross_sell', 'extras']
      return Object.entries(this.product)
        .filter(([key]) => !excludeKeys.includes(key))
        .some(([, value]) => value === null || value === '')
    },
    actionBtn () {
      if (this.isEdit) {
        this.editProduct()
      } else {
        this.addProduct()
      }
    },
    async getPos () {
      console.log(this.business._id)
      this.pos = await terminalsApi.list(this.business._id, '')
    },
    async getCategories () {
      if (this.product.terminal) {
        this.categories = await categoriesApi.listByPos(this.product.terminal, '', 1)
      }
    },
    async getExtras () {
      if (this.product.terminal) {
        this.extras = await extrasApi.listByPos(this.product.terminal, '', 1)
      }
    },
    async getComplements () {
      if (this.product.terminal) {
        this.complements = await catalogApi.listByPos(this.product.terminal, '', 1)
      }
    },
    async addProduct () {
      if (await catalogApi.add(this.product, this.imageData)) {
        this.isSavingData = false
        this.isDialogOpen = false
        this.$emit('refreshList')
      } else {
        this.isSavingData = true
      }
    },
    async editProduct () {
      if (await catalogApi.edit(this.product, this.imageData)) {
        this.isSavingData = false
        this.isDialogOpen = false
        this.$emit('refreshList')
      } else {
        this.isSavingData = true
      }
    },
    async uploadImage () {
      if (this.imageData != null) {
        console.log('test')
      }
    },
    onFileChange (event) {
      const file = event.target.files[0]
      if (file && file.type.startsWith('image/')) {
        this.imageData = file
        this.imageUrl = URL.createObjectURL(file)
      } else {
        alert('Por favor selecciona un archivo de imagen válido.')
      }
    },
    selectFile () {
      this.$refs.fileInput.click()
    }

  }
}
</script>

<style scoped>
  @import '@/assets/styles/forms.css';
</style>
